import React from 'react';
import { DateTime } from 'luxon';
import CustomTooltip from '../../../components/CustomTooltip';

const getSuiteColumns = ({ hasPermission, getBadgeStatus, openReschedule, Show }) => [
    {
        title: '#',
        render: (rowData) => <span>{rowData.idAddress}</span>,
        field: 'idAddress',
        searchable: true,
        visible: true,
    },
    {
        title: 'Guía',
        render: (rowData) => <span>{rowData.trackingId}</span>,
        field: 'trackingId',
        searchable: true,
        visible: hasPermission('feature:rescheduling-show-column-trackingid'),
    },
    {
        title: 'IdExterno',
        render: (rowData) => <span>{rowData.externalId}</span>,
        field: 'externalId',
        searchable: true,
        visible: hasPermission('feature:rescheduling-show-column-externalid'),
    },
    {
        title: 'Nombre Destinatario',
        render: (rowData) => <span>{rowData.receiverName}</span>,
        visible: hasPermission('feature:rescheduling-show-column-receivername'),
    },
    {
        title: 'Dirección Destinatario',
        render: (rowData) => <span>{rowData.receiverAddress}</span>,
        field: 'address',
        searchable: true,
        visible: hasPermission('feature:show-recipient-address'),
    },
    {
        title: 'Teléfono Destinatario',
        render: (rowData) => <span>{rowData.receiverPhone}</span>,
        field: 'reference1',
        searchable: true,
        visible: hasPermission('feature:show-reference1-address'),
    },
    {
        title: 'Estado',
        render: (rowData) => getBadgeStatus(rowData.state),
    },
    {
        title: 'Ciudad',
        render: (rowData) => <span>{rowData.city}</span>,
        field: 'city',
        searchable: true,
        visible: hasPermission('feature:rescheduling-show-column-city'),
    },
    {
        title: 'Novedad',
        render: (rowData) => <span>{rowData.novelty}</span>,
        field: 'novelty',
        searchable: true,
        visible: hasPermission('feature:rescheduling-show-column-novelty'),
    },
    {
        title: 'Comentario Novedad/Nota',
        render: (rowData) => <span>{rowData.comment}</span>,
        visible: hasPermission('feature:rescheduling-show-column-noveltynote'),
    },
    {
        title: 'Motivo de rechazo',
        render: (rowData) =>
            rowData.state === 'REJECTED'
                ? <span>{rowData.reschedulingLogResponse?.data?.observaciones_rechazo_solucion ?? '-'}</span>
                : <span>-</span>,
    },
    {
        title: 'Valor de recaudo',
        render: (rowData) => <span>{rowData.collection}</span>,
        field: 'collection',
        searchable: true,
        visible: hasPermission('feature:rescheduling-show-column-collection'),
    },
    {
        title: 'Producto',
        render: (rowData) =>
            rowData.product?.length > 30
                ? <CustomTooltip data={rowData.product.split(',')} />
                : <span>{rowData.product}</span>,
        visible: hasPermission('feature:rescheduling-show-column-product'),
    },
    {
        title: 'Intentos de entrega',
        render: (rowData) => (
            <span className='badge badge-pill badge-light d-flex justify-content-center align-items-center'>
                {rowData.deliveryAttempts}
            </span>
        ),
        visible: hasPermission('feature:rescheduling-show-column-attempts'),
    },
    {
        title: 'Intentos de reprogramación',
        render: (rowData) => (
            <span className='badge badge-pill badge-light d-flex justify-content-center align-items-center'>
                {rowData.rescheduling_attempts ?? '-'}
            </span>
        ),
        visible: hasPermission('feature:rescheduling-show-column-attempts'),
    },
    {
        title: 'Fecha Estado',
        render: (rowData) => (
            <span>
                {rowData.lastUpdateDate && String(rowData.lastUpdateDate).includes('/')
                    ? DateTime.fromFormat(String(rowData.lastUpdateDate), 'YYYY/MM/dd').toFormat('dd-MM-YYYY')
                    : rowData.lastUpdateDate ? String(rowData.lastUpdateDate) : ''}
            </span>
        ),
        visible: hasPermission('feature:rescheduling-show-column-lastupdatedate'),
    },
    {
        title: 'Fecha Creado',
        render: (rowData) => (
            <span>
                {rowData.createdDate && String(rowData.createdDate).includes('/')
                    ? DateTime.fromFormat(String(rowData.createdDate), 'YYYY/MM/dd').toFormat('dd-MM-YYYY')
                    : rowData.createdDate ? String(rowData.createdDate) : ''}
            </span>
        ),
        visible: hasPermission('feature:rescheduling-show-column-createddate'),
    },
    {
        title: 'Fecha Tentativa de Entrega',
        render: (rowData) => (
            <span>
                {rowData.deliveryDate && String(rowData.deliveryDate).includes('/')
                    ? DateTime.fromFormat(String(rowData.deliveryDate), 'YYYY/MM/dd').toFormat('dd-MM-YYYY')
                    : rowData.deliveryDate ? String(rowData.deliveryDate) : ''}
            </span>
        ),
        visible: hasPermission('feature:rescheduling-show-column-rescheduleddate'),
    },
    {
        title: 'Remitente',
        render: (rowData) => <span>{rowData.shipper}</span>,
        visible: hasPermission('feature:show-client-address'),
    },
    {
        title: 'Operador',
        render: (rowData) => <span>{rowData.operator}</span>,
        visible: hasPermission('feature:show-operator-address'),
    },
    {
        title: 'Acciones',
        render: (rowData) => (
            <>
                {rowData.state === 'REJECTED' && (
                    <Show when='feature:rescheduling'>
                        <button
                            title='Reprogramar'
                            className='btn btn-warning btn-sm btn-circle mr-2'
                            type='button'
                            onClick={() => openReschedule(rowData)}>
                            <i className='fas fa-calendar fa-xs'></i>
                        </button>
                    </Show>
                )}
            </>
        ),
    },
];

export default getSuiteColumns;
